<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemTipoEnvioSir2Monit"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            situacao.id === 0 ? adicionarTipoEnvioSir2Monit() : editarTipoEnvioSir2Monit()
          "
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="situacao.descricao"
                >Situação</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <div>Solicitação de arquivo</div>
              <toggle-button v-model="situacao.solicitaarquivo" :sync="true" />
            </div>
          </div>

          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import Sirs from './mixim/sirs'
Vue.mixin(Sirs)

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo de envio SIR',
      titlePDF: 'Lista de Tipo de apresentação',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'descricao', label: 'Tipo de envio', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      listagemTipoEnvioSir2Monit: [],
      situacao: {},
      actions: [
        {
          button: true,
          funcaoButton: 'editTipoEnvioSir2Monit',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTipoEnvioSir2Monit',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    deleteTipoEnvioSir2Monit: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSir2 + 'TipoEnvioSir2Monit/Excluir/id?id=' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoEnvioSir2Monit()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.situacao = {}
      this.situacao.id = 0
      this.titleModal = 'Adicionar tipo de envio SIR'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editarTipoEnvioSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSir2 + 'TipoEnvioSir2Monit/Alterar',
          this.situacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoEnvioSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarTipoEnvioSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSir2 + 'TipoEnvioSir2Monit/Adicionar',
          this.situacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoEnvioSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editTipoEnvioSir2Monit: function (_, item) {
      this.situacao = { ...item }
      this.titleModal = 'Editar tipo de envio SIR'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    }
  },
  mounted: function () {
    this.listarTipoEnvioSir2Monit()
  }
}
</script>
